import { ReadyToPay } from './ReadyToPay';

export default ReadyToPay;
